import jsPDF from "jspdf";
import { toPng } from "html-to-image";
import html2canvas from "html2canvas";
export function downloadPDF(id, title, width, zoomfactor) {
  var canvas = document.getElementById(id);
  var canvasImg = canvas.toDataURL("#ffffff", "image/jpeg", 1.0);
  var doc = new jsPDF("landscape");
  var filetitle = title;
  var imgWidth = width * zoomfactor;
  var imgHeight = (canvas.height * imgWidth) / canvas.width;
  doc.setFontSize(20);
  doc.setFont("optimare");
  doc.text(130, 15, filetitle);
  doc.setFontSize(10);
  doc.addImage(
    canvasImg,
    "JPEG",
    doc.internal.pageSize.width / 2 - imgWidth / 2,
    doc.internal.pageSize.height / 2 - imgHeight / 2,
    imgWidth,
    imgHeight
  );

  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  const formattedDateTime = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
  const filename = `${title}_${formattedDateTime}.pdf`;

  doc.save(`${filename}.pdf`);
}
export async function downloadPDFFOrNivo(id, title = "", width, zoomFactor) {
  if (!id?.current) {
    return;
  }
  var canvas = id.current;
  if (canvas) {
    var canvasImg = await toPng(canvas);
    var doc = new jsPDF("landscape");
    var filetitle = title;
    var imgWidth = width * zoomFactor;
    var imgHeight = (canvas.height * imgWidth) / canvas.width;
    doc.setFontSize(20);
    doc.setFont("optimare");
    doc.text(135, 10, filetitle);
    doc.setFontSize(10);

    var img = new Image();
    img.onload = function () {
      doc.addImage(this, -40, 20);
      // doc.text(50, 20, filetitle);
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      const formattedDateTime = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
      const filename = `${title}_${formattedDateTime}.pdf`;
      doc.save(`${filename}.pdf`);
    };
    img.crossOrigin = "";
    img.src = canvasImg;
  }
}

export async function downloadCanvasAsPDF(canvas, title, width, zoomFactor) {
  if (!canvas) return;

  try {
    const canvasImg = await toPng(canvas);
    const doc = new jsPDF("landscape");
    const imgWidth = width * zoomFactor;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    doc.setFontSize(20);
    doc.setFont("optimare");
    doc.text(title, 130, 15);
    doc.setFontSize(10);

    doc.addImage(
      canvasImg,
      "PNG",
      doc.internal.pageSize.width / 2 - imgWidth / 2,
      doc.internal.pageSize.height / 2 - imgHeight / 2,
      imgWidth,
      imgHeight
    );

    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const formattedDateTime = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
    const filename = `${title}_${formattedDateTime}.pdf`;

    doc.save(filename);
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
}

export async function printDocument(ref, title, orientation = "portrait") {
  if (!ref?.current) {
    console.error("Element not found!");
    return;
  }

  try {
    const input = ref.current;
    if (input) {
      const canvas = await html2canvas(input);
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: orientation,
        unit: "pt",
        format: [canvas.width, canvas.height],
      });

      pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);

      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      const formattedDateTime = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
      const filename = `${title}_${formattedDateTime}`;

      pdf.save(`${filename}.pdf`);
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
}
